import { useEffect } from "react";
import { useOwnProfileQuery } from "./useOwnProfileQuery";
import { readStoredIsSuperadmin, storeIsSuperadmin } from "../services/auth/persistLoginSession";

const pickIsSuperadmin = (profile: { is_superadmin?: boolean }): boolean => profile.is_superadmin === true;

/**
 * Whether the signed-in user is a superadmin. Asks `/auth/me` (OAuth sign-ins never
 * store the flag) and falls back to the flag saved at password login while loading
 * or if the request fails. A backend answer is written back to storage.
 */
export const useIsSuperadmin = (): boolean => {
  const { data } = useOwnProfileQuery(pickIsSuperadmin);
  useEffect(() => {
    if (data !== undefined) storeIsSuperadmin(data);
  }, [data]);
  return data ?? readStoredIsSuperadmin();
};
